import { Stack, Typography } from "@mui/material";

interface IDialogInfoRow {
  label: string;
  value: string;
}

const DialogInfoRow = ({ label, value }: IDialogInfoRow) => {
  return (
    <Stack direction="row" justifyContent="space-between">
      <Typography variant="text1xl500" color="dsNeutral.v400">
        {label}
      </Typography>
      <Typography variant="text1xl500" color="dsBase.v200">
        {value}
      </Typography>
    </Stack>
  );
};

export default DialogInfoRow;
